import styled from 'styled-components';

export const CardTags = styled.ul`
  display: flex;
  flex-flow: row;
  flex-wrap: wrap;
  list-style-type: none;
  padding: 0;
  margin: 0;
  justify-content: center;
`;

export const CardTagsList = styled.li`
  padding: 0;
  margin: 0;
`;

export const CardTag = styled.a`
  padding: 5px;
`;

export const SectionHeadline = styled.div`
  position: relative;
  text-align: center;

  @media (min-width: 575px) {
    margin: 1.5rem 0 70px;
  }

  @media (max-width: 575px) {
    display: flex;
    flex-flow: column;
    margin: 1.5rem 0 50px;
  }

  h2 {
    color: #4a4a4a;

    @media (max-width: 768px) {
      padding-right: 20px;
      line-height: 30px;
      margin-bottom: 1rem;
      font-size: 20px;
    }
  }

  p {
    max-width: 900px;
    margin-left: auto;
    margin-right: auto;

    @media (max-width: 768px) {
      display: none;
    }
  }

  h3 {
    font-size: 20px;
  }

  a {
    font-size: 12px;
    letter-spacing: 2.18px;
    text-transform: uppercase;
    height: 100%;
    display: flex;
    align-items: center;
    color: #000;

    @media (min-width: 576px) {
      position: absolute;
      right: 0;
      top: 0;
    }

    @media (max-width: 575px) {
      justify-content: center;
    }

    &:after {
      content: '';
      display: inline-block;
      width: 14px;
      height: 10px;
      background-repeat: no-repeat;
      margin-left: 5px;
    }
  }
`;

export const Container = styled.div`
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;

  @media (min-width: 576px) {
    max-width: 540px;
  }

  @media (min-width: 768px) {
    max-width: 720px;
  }

  @media (min-width: 992px) {
    max-width: 960px;
  }

  @media (min-width: 1200px) {
    max-width: 1140px;
  }

  @media (min-width: 1280px) {
    max-width: 1220px;
  }

  &.zeropadding_responsive {
    @media (max-width: 575.98px) {
      padding-right: 0px;
      padding-left: 0px;
    }
  }

  .row {
    .col {
      flex-basis: 0;
      flex-grow: 1;
      max-width: 100%;

      position: relative;
      width: 100%;
      min-height: 1px;
      padding-right: 15px;
      padding-left: 15px;
    }
  }
`;

export const InsightsSection = styled.section`
  margin-top: 50px;
  background: #ebebeb;
  padding: 50px 0;
  overflow: hidden;
  display: ${({ dir }) => (dir === 'rtl' ? 'none' : '')};

  .arrow {
    svg {
      width: 0.875rem;
      fill: black;
    }
  }

  &[dir='ltr'] {
    .arrow {
      svg {
        margin-left: 5px;
      }
    }
  }

  &[dir='rtl'] {
    .arrow {
      svg {
        margin-right: 5px;
      }
    }
  }

  div[class*='IndustryInsightsstyled__SectionHeadline-'] {
    margin-bottom: 0;
    margin-top: 0px;
  }

  &.insightshome_slider {
    .insights_cardcontainer {
      margin: 0px 6px;

      @media (max-width: 575.98px) {
        width: 100%;
        margin: 0px 4px;
      }
    }

    @media (max-width: 575.98px) {
      margin-top: 30px;
    }

    .section_caption {
      margin: 0px;

      .view_all {
        &[dir='ltr'] {
          right: 0;
        }
      }

      @media (max-width: 767.98px) {
        padding-bottom: 20px;
        padding-left: 0px;
        display: flex;
        justify-content: flex-start;
        justify-content: flex-start;
        align-items: center;
      }

      @media (max-width: 575.98px) {
        margin: 0px 30px;
      }

      .home_link {
        @media (max-width: 767.98px) {
          align-items: center;
          top: auto;
        }
      }
    }
  }

  &.insights_slider_mb {
    margin-bottom: -50px;
  }
`;

export const InsightsSlider = styled.div`
  padding: 30px 50px 0px;

  @media (max-width: 1200px) {
    padding: 10px 0 0;
  }

  @media (max-width: 576px) {
    padding: 0px;
  }

  .slick-prev {
    @media (min-width: 1200px) {
      left: -70px;
      margin-top: -15px;
    }

    @media (max-width: 1200px) {
      left: -30px;
    }

    @media (max-width: 992px) {
      left: -35px;
    }
  }

  .slick-next {
    @media (min-width: 1200px) {
      right: -70px;
      margin-top: -15px;
    }

    @media (max-width: 1200px) {
      right: -30px;
    }

    @media (max-width: 992px) {
      right: -35px;
    }
  }

  .slick-dots {
    @media (max-width: 768px) {
      padding-top: 30px;
    }
  }

  &.margin_slider_sv {
    @media (max-width: 991.98px) {
      margin: 0 15px;
    }

    @media (max-width: 575.98px) {
      margin: 0px;
    }
  }
`;

export const SliderCard = styled.div`
  display: flex !important;
  flex-flow: column;
  justify-content: space-between;
  height: 480px;
  margin: 0 6px;
  text-align: center;
  width: 320px !important;
  overflow: hidden;
  position: relative;
  background-color: #d8d8d8;

  @media (min-width: 1200px) {
    width: 350px !important;
  }

  @media (max-width: 1199px) {
    width: 300px !important;
  }

  @media (max-width: 991px) {
    width: 340px !important;
  }

  @media (max-width: 575px) {
    width: 315px !important;
    margin: 0 4px;
  }

  .card-title {
    font-size: 10px;
    color: #000;
    letter-spacing: 1.8px;
    text-transform: uppercase;
  }

  h3 {
    width: 70%;
    margin: 0 auto;
  }

  p {
    margin: 0 0 3.5rem;
    color: #fff;
  }

  a {
    font-size: 12px;
    text-transform: uppercase;

    &[class*='CardTagsstyled__'],
    &[class*='Linkstyled__Link'] {
      color: #fff;

      &:hover {
        color: #fff;
      }
    }

    &[class*='CardTagsstyled__'] {
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }

    &[class*='Linkstyled__Link'] {
      text-decoration: underline;

      &:hover {
        text-decoration: none;
      }
    }

    &.play-icon {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 1;

      &:after {
        content: '';
        display: inline-block;
        background-repeat: no-repeat;
        width: 93px;
        height: 94px;
        margin: 0 auto;
      }
    }
  }

  &.video-card {
    div[class*='SliderCardstyled__SliderCardText-'] {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      margin: 0 auto;
      color: #fff;
      z-index: 2;
      height: 100%;
      display: flex;
      flex-flow: column;
      justify-content: flex-end;
    }
  }

  div[class*='SliderCardstyled__CardImage-'] {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;

    .lazyImg {
      object-fit: cover;
      position: absolute;
      top: 0;
      z-index: 1;
      width: auto;
      height: 100%;
      left: 50%;
      transform: translate(-50%, 0);
    }
  }
`;

export const SliderCardPress = styled.div`
  display: flex !important;
  flex-flow: column;
  justify-content: space-between;
  height: 480px;
  margin: 0 6px;
  text-align: center;
  width: 320px !important;
  overflow: hidden;
  position: relative;
  background-color: #fff;
  padding: 50px 0 0 !important;

  @media (min-width: 1200px) {
    width: 350px !important;
  }

  @media (max-width: 1199px) {
    width: 300px !important;
  }

  @media (max-width: 991px) {
    width: 340px !important;
  }

  @media (max-width: 575px) {
    width: 315px !important;
    margin: 0 4px;
  }

  .card-title {
    font-size: 10px;
    color: #000;
    letter-spacing: 1.8px;
    text-transform: uppercase;
  }

  h3 {
    width: 70%;
    margin: 0 auto;
  }

  a {
    font-size: 12px;
    text-transform: uppercase;

    &[class*='Linkstyled__Link'] {
      position: absolute;
      bottom: 0;
      width: 100%;
      display: block;
      text-decoration: none;
      color: #fff;
      text-align: center;
      background: #1b7bdd;
      padding: 20px 0;

      &:hover {
        background-color: #165ca3;
        color: #fff;
        text-decoration: none;
      }
    }
  }

  div[class*='SliderCardstyled__CardImage'] {
    height: 232px;
    overflow: hidden;

    &:after {
      content: none;
    }

    .lazyImg {
      width: 100%;
    }
  }
`;

export const CardImage = styled.div`
  overflow: hidden;
  width: 100%;
  position: relative;

  &:after {
    background: rgba(0, 0, 0, 0.3);
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
  }
`;

export const SliderCardText = styled.div`
  display: flex !important;
  flex-flow: column;
  justify-content: space-between;
  height: 100%;
  position: relative;
  padding: 50px 25px 20px !important;
  z-index: 2;
  color: #fff;
`;
